import { AssetType } from '@ve-pro/enums/asset'

export enum AsideType {
  // 资源组
  AssetGroup = 'assetGroup',
  All = 'all',
  // 项目素材
  Material = 'material',
  // 个人资产库
  AssetLibrary = 'assetLibrary',
  // 音效
  Sound = 'sound',
  // 背景音乐
  BGM = 'bgm',
  // 字幕
  Subtitle = 'subtitle',
  // 模版
  Template = 'template',
  // 完整视频
  FullVideo = 'fullVideo',
  // 片段
  Fragment = 'fragment',
  // 翻译
  Translate = 'translate',
  // 替换
  Replace = 'replace',
  // 多比例模版
  RatioTemplate = 'ratioTemplate',
}

export enum ResourceType {
  IMAGE = 1, // 图片
  ANIMATION, // 动图
  SOUND, // 音效
  BGM, // bgm
  PARTICLE, // 粒子
  VIDEO, // 视频
  TRANSITION, // 转场
  FILTER, // 滤镜
}

// 当前文件上传状态
export enum UploadFileStatus {
  waiting,
  uploadStart,
  uploading,
  /** 资产库内的资源已存在 */
  uploadProAlready,
  /** 资产组内的资源已存在 */
  uploadGroAlready,
  uploadSuccess,
  uploadError,
  uploadAdding, // 同步到项目素材中，避免重复发起请求
}

export const CommonAssetMap: Record<number, AssetType> = {
  1: AssetType.Video,
  2: AssetType.Image,
  3: AssetType.Animation,
  4: AssetType.Audio,
  6: AssetType.Text,
  9: AssetType.Transition,
  10: AssetType.Filter,
}
